import axios from "axios";
import {
  ADD_SERVER,
  GET_SERVER_LIST,
  DELETE_SERVER,
  UPDATE_SERVER,
} from "../constant";
const { decorate, observable, action } = require("mobx");

class Server {
  serverList = [];

  async getServerList() {
    let response = await axios.get(GET_SERVER_LIST);
    let data = await response.data;
    this.serverList = data;
  }

  async addServer(server, USER) {
    try {
      let response = await axios.post(ADD_SERVER, {
        server: server,
        user: USER,
      });
      await this.getServerList();
      return response;
    } catch (error) {
      throw error;
    }
  }

  async updateServer(server, USER) {
    try {
      let response = await axios.put(UPDATE_SERVER, {
        server: server,
        user: USER,
      });
      await this.getServerList();
      return response;
    } catch (e) {
      throw e;
    }
  }

  async deleteServer(server, USER) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      let response = await axios.delete(
        DELETE_SERVER,
        {
          data: { server: server, user: USER },
        },
        config
      );
      await this.getServerList();
      return response;
    } catch (error) {
      throw error;
    }
  }
}

decorate(Server, {
  serverList: observable,
  getServerList: action,
  addServer: action,
  updateServer: action,
  deleteServer: action,
});

const server = new Server();
export default server;
